'use client';

import { isRamadan } from '@/src/lib/utils/checkIfRamadan';
import { ISchedules } from '@/src/types/stores';
import { useTranslations } from 'next-intl';
import React from 'react';
import { useTodaySchedule } from './StoreAvailability';
import CurrentLanguageText from '@/src/components/helper/CurrentLanguageText';
import { ConvertTimeTo12HourFormat } from '@/src/lib/utils/formatDay';
import { cn } from '@/src/lib/utils/command';
import Typography from '@/src/components/ui/typography';

const WorkingDays = ({ scheduleDays, isOpen }: { scheduleDays: ISchedules[]; isOpen: boolean }) => {
  const t = useTranslations('stores');
  const normalSchedule = scheduleDays.filter((item) => item.scheduleType === 1);
  const ramdanSchedule = scheduleDays.filter((item) => item.scheduleType === 2);

  const currentScheduleDays = isRamadan() ? ramdanSchedule : normalSchedule;
  const todaySchedule = useTodaySchedule(currentScheduleDays[0]?.branchScheduleDays || []);

  return (
    <div className="styled-scroll my-3 flex gap-3 overflow-x-auto py-2">
      {currentScheduleDays?.map((item, index) => (
        <div
          key={index}
          className="styled-scroll grid w-full overflow-hidden rounded-xl border bg-white text-center"
        >
          {item.branchScheduleDays?.map((daySchedule, dayIndex) => (
            <div
              key={dayIndex}
              className={`${
                todaySchedule?.day !== daySchedule.day
                  ? ''
                  : daySchedule.isClosed || !isOpen
                    ? 'bg-red-200/20 text-red-400'
                    : 'text-success font-bold'
              } flex items-center justify-between gap-3 border-b px-2 py-4`}
            >
              <div>
                <CurrentLanguageText
                  arabicName={daySchedule.arabicDayString}
                  englishName={daySchedule.englishDayString}
                />
                {/* <span className="mx-1">
                  {todaySchedule?.day !== daySchedule.day
                    ? daySchedule.isClosed && t('close')
                    : daySchedule.isClosed || !isOpen
                      ? t('close')
                      : t('open')}
                </span> */}
              </div>
              {/* <span
                className={`${daySchedule.isClosed || todaySchedule?.day !== daySchedule.day ? 'bg-gray-5/50' : 'bg-success/20'} block h-[1px] w-full`}
              /> */}

              {daySchedule.isClosed ? (
                <Typography color={'gray'}>{t('unavailable')}</Typography>
              ) : (
                <div className="flex items-center">
                  {daySchedule.branchScheduleOpeningHours?.map((hours, hoursIndex) => (
                    <p
                      className={cn(
                        'flex justify-center ps-4 text-xs last:border-0 last:pe-0 lg:text-sm',
                        daySchedule.branchScheduleOpeningHours.length > 1
                          ? 'border-primary border-e pe-4'
                          : '',
                      )}
                      key={hoursIndex}
                    >
                      {ConvertTimeTo12HourFormat(hours.startHour)} -{' '}
                      {ConvertTimeTo12HourFormat(hours.endHour)}
                    </p>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default WorkingDays;
